//@vendor
const Immutable = require('immutable');
const { handleActions } = require('redux-actions');
//@actions
const { simpleActions } = require('../actions/segmentedLoanProducts');

const setInitialState = (retailLoanSegmented = false) => Immutable.fromJS({
    isFetching: false,
    error: false,
    success: false,
    retailLoanSegmented,
    errorCount: 1,
    type: null
});

const segmentedLoanProductsReducer = handleActions(
    {
        [simpleActions.segmentedLoanProducts]: state =>
            state.merge({
                isFetching: true,
                error: false,
                success: false
            }),
        [simpleActions.segmentedLoanProductsSuccess]: state =>
            state.merge({
                isFetching: false,
                error: false,
                success: true
            }),
        [simpleActions.segmentedLoanProductsError]: (state, action) =>
            state.merge({
                isFetching: false,
                error: action.payload.error,
                success: false
            }),
        [simpleActions.segmentedLoanProductsErrorCount]: (state, action) =>
            state.merge({
                errorCount: state.get('errorCount') + 1
            }),
        [simpleActions.segmentedLoanRetailSuccess]: state =>
            state.merge({retailLoanSegmented: true}),
        [simpleActions.segmentedLoanProductsReset]: state =>
            state.merge(setInitialState(state.get('retailLoanSegmented'))),
        [simpleActions.saveEasyLoanType]: (state, action) =>
        state.merge({
            type: action.payload
        }),
        [simpleActions.saveCardLoanType]: (state, action) =>
        state.merge({
            type: action.payload
        }),
    },
    setInitialState()
);

module.exports = segmentedLoanProductsReducer;
module.exports.setInitialState = setInitialState;
